function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Tinymce from '@/components/Tinymce/index';
import { brandListApi, productGuaranteeApi, templateListApi, productCreateApi, productDetailApi, productUpdateApi, productCouponListApi, guaranteeListApi, copyConfigApi, copyProductApi, importProductApi, getConfigApi } from '@/api/product';
import { getAdminInfoByTokenApi } from '@/api/user';
import { Debounce } from '@/utils/validate';
import { mapGetters, mapState } from 'vuex';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
import Cookies from 'js-cookie';
import creatAttr from '../components/creatAttr';
import { uploadImage } from '@/utils/ZBKJIutil';
import { getToken } from '@/utils/auth';
import edit from '@/components/Category/edit.vue';
import { productAuditSwitchInfoApi, getBaseInfoApi } from '@/api/merchant';
import { systemFormPageApi } from '@/api/systemForm';
import { useProduct } from '@/hooks/use-product';
var _useProduct = useProduct(),
  handlerCreatFromUse = _useProduct.handlerCreatFromUse;
import product from '@/mixins/product';
import { defaultObj, objTitle } from './default';
export default {
  name: 'ProductProductAdd',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          var condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  mixins: [product],
  //此js存放商品的部分函数方法
  components: {
    edit: edit,
    Tinymce: Tinymce,
    creatAttr: creatAttr
  },
  data: function data() {
    return {
      showLockFu: false,
      showBusinessLockDividend: false,
      //批量添加规格的值
      oneFormBatch: [{
        image: '',
        price: void 0.01,
        cost: void 0.01,
        otPrice: void 0.01,
        stock: void 0,
        barCode: '',
        itemNumber: '',
        weight: void 0,
        volume: void 0,
        brokerage: void 0,
        brokerageTwo: void 0,
        cdkeyId: null,
        cdkeyLibraryName: '',
        expand: '',
        vipPrice: void 0,
        directPushPrice: 0,
        // ✅ 新增
        recommendPrice: 0 // ✅ 新增
      }],
      frontDomain: localStorage.getItem('frontDomain'),
      htmlKey: 0,
      formThead: Object.assign({}, objTitle),
      form: 2,
      url: '',
      copyConfig: {},
      labelarr: [],
      isDisabled: this.$route.params.isDisabled === '1' ? true : false,
      isCopy: this.$route.params.isCopy === '1' ? true : false,
      //是否是采集
      isShowInStreet: false,
      // 是否展示在店铺街
      isSupplier: false,
      // 是否为供货商（onboardingType=2）
      props2: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false,
        checkStrictly: true
      },
      props1: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false
      },
      tabs: [],
      fullscreenLoading: false,
      props: {
        multiple: true
      },
      active: 0,
      OneattrValue: [Object.assign({}, defaultObj.attrValueList[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValueList[0])],
      // 多规格
      manyTabTit: {},
      manyTabDate: {},
      // 生成规格表格中的头部标题
      grid2: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      isBtn: false,
      manyFormValidate: [],
      currentTab: '1',
      isChoice: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      ruleValidate: {
        name: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        categoryId: [{
          required: true,
          message: '请选择平台商品分类',
          trigger: 'change'
        }],
        cateIds: [{
          required: true,
          message: '请选择商户商品分类',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: '请输入商品简介',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        image: [{
          required: true,
          message: '请上传商品图',
          trigger: 'change'
        }],
        sliderImages: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }],
        brandId: [{
          required: true,
          message: '请选择商品品牌',
          trigger: 'change'
        }],
        deliveryMethodList: [{
          required: true,
          message: '请选择配送方式',
          type: 'array',
          trigger: 'change'
        }],
        isSplit: [{
          required: true,
          message: '请选择是否分单',
          trigger: 'change'
        }],
        ratio: [{
          required: true,
          message: '请输入商品让利比例',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === undefined || value === null) {
              callback(new Error('请输入商品让利比例'));
            } else if (!/^\d+$/.test(value)) {
              callback(new Error('让利比例必须为整数'));
            } else if (parseInt(value, 10) < 3 || parseInt(value, 10) > 30) {
              callback(new Error('让利比例范围为3%~30%的整数'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        businessManagerRatio: [{
          required: true,
          message: '请输入商务经理分红比例',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            var num = parseFloat(value);
            if (isNaN(num) || num < 0 || num > 1) {
              callback(new Error('分红比例必须在0到1之间'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        seniorBusinessManagerRatio: [{
          required: true,
          message: '请输入高级商务经理分红比例',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            var num = parseFloat(value);
            if (isNaN(num) || num < 0 || num > 1) {
              callback(new Error('分红比例必须在0到1之间'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        directorRatio: [{
          required: true,
          message: '请输入总监分红比例',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            var num = parseFloat(value);
            if (isNaN(num) || num < 0 || num > 1) {
              callback(new Error('分红比例必须在0到1之间'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        seniorDirectorRatio: [{
          required: true,
          message: '请输入高级总监分红比例',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            var num = parseFloat(value);
            if (isNaN(num) || num < 0 || num > 1) {
              callback(new Error('分红比例必须在0到1之间'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        presidentRatio: [{
          required: true,
          message: '请输入总裁分红比例',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            var num = parseFloat(value);
            if (isNaN(num) || num < 0 || num > 1) {
              callback(new Error('分红比例必须在0到1之间'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      },
      tempRoute: {},
      keyNum: 0,
      isShowAttr: false,
      guaranteeList: [],
      brandList: [],
      search: {
        limit: this.$constants.page.limit[0],
        page: 1,
        cid: '',
        brandName: ''
      },
      totalPage: 0,
      total: 0,
      loading: false,
      loadingBtn: false,
      isShowGroup: 'alone',
      guaranteeGroupList: [],
      guaranteeNew: [],
      guaranteeName: [],
      multiples: true,
      productClassify: [],
      //平台商品分类
      productType: [{
        tit: '普通商品',
        id: 0,
        tit2: '实体货物'
      }, {
        tit: '云盘商品',
        id: 5,
        tit2: '同一链接发货'
      }, {
        tit: '卡密商品',
        id: 6,
        tit2: '不同充值码发货'
      }],
      upload: {
        videoIng: false // 是否显示进度条；
      },
      videoLink: '',
      //视频地址
      progress: 10,
      // 进度条默认0
      myHeaders: {
        'X-Token': getToken()
      },
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=创建，1=编辑
        prent: {},
        // 父级对象
        data: {},
        biztype: {
          name: '产品分类',
          value: 1,
          shortName: '产品'
        } // 统一主业务中的目录类型
      },
      //商品分类
      isSwitch: false,
      //商户开关
      productSwitch: false,
      //商品是否需要审核 true需要审核，false免审
      canSel: true,
      // 规格图片添加判断
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      formDynamics: {
        ruleName: '',
        ruleValue: []
      },
      isSpecialMerchant: false // 新增标记
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.bus.$emit('onTagsViewRefreshRouterView', this.$route.path);
    next();
  },
  computed: _objectSpread(_objectSpread({
    ratioRules: function ratioRules() {
      var _this2 = this;
      return [{
        required: true,
        message: '请输入商品让利比例',
        trigger: 'blur'
      }, {
        validator: function validator(rule, value, callback) {
          if (!value) {
            callback(new Error('请输入商品让利比例'));
          } else if (!/^\d+$/.test(value)) {
            callback(new Error('让利比例必须为整数'));
          } else {
            var min = _this2.isSpecialMerchant ? 5 : 3;
            var max = _this2.isSpecialMerchant ? 80 : 30;
            var range = _this2.isSpecialMerchant ? '5%~80%' : '3%~30%';
            if (parseInt(value, 10) < min || parseInt(value, 10) > max) {
              callback(new Error("\u8BA9\u5229\u6BD4\u4F8B\u8303\u56F4\u4E3A".concat(range, "\u7684\u6574\u6570")));
            } else {
              callback();
            }
          }
        },
        trigger: 'blur'
      }];
    },
    businessLockDividendSum: function businessLockDividendSum() {
      var sum = (parseFloat(this.formValidate.businessManagerRatio) || 0) + (parseFloat(this.formValidate.seniorBusinessManagerRatio) || 0) + (parseFloat(this.formValidate.directorRatio) || 0) + (parseFloat(this.formValidate.seniorDirectorRatio) || 0) + (parseFloat(this.formValidate.presidentRatio) || 0);
      return sum;
    },
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  }, mapState({
    systemFormList: function systemFormList(state) {
      return state.mobildConfig.systemFormList;
    }
  })), mapGetters(['merPlatProductClassify', 'merProductClassify', 'productBrand', 'shippingTemplates'])),
  created: function created() {
    this.formValidate.type = Number(this.$route.params.productType); //商品类型
    this.tempRoute = Object.assign({}, this.$route);
  },
  mounted: function mounted() {
    // 判断是否展示在店铺街
    this.isShowInStreet = Cookies.get('isShowInStreet') === 'true';
    // 判断是否为供货商（onboardingType=2）
    this.isSupplier = parseInt(Cookies.get('onboardingType') || '1') === 2;
    this.getConfig();
    this.formValidate.attrs = [];
    this.formValidate.sliderImages = [];
    if (checkPermi(['merchant:plat:product:category:cache:tree'])) this.$store.dispatch('product/getAdminProductClassify');
    if (!localStorage.getItem('merProductClassify') && checkPermi(['merchant:product:category:cache:tree'])) this.$store.dispatch('product/getMerProductClassify');
    if (checkPermi(['merchant:plat:product:brand:cache:list'])) this.$store.dispatch('product/getMerProductBrand');
    if (!localStorage.getItem('shippingTemplates')) this.$store.dispatch('product/getShippingTemplates');
    if (checkPermi(['merchant:plat:product:guarantee:list'])) this.getProductGuarantee();
    if (checkPermi(['merchant:product:guarantee:group:list'])) this.getGuaranteeGroupList();
    if (!localStorage.getItem('systemFormList') && checkPermi(['merchant:system:form:page'])) this.getSystemFormList();
    this.setTagsViewTitle();
    if (this.$route.params.id && this.$route.params.id != 0) {
      if (checkPermi(['merchant:product:info'])) this.getInfo();
    } else {
      this.isShowAttr = true;
    }
    if (this.isCopy && checkPermi(['merchant:plat:product:brand:cache:list'])) this.getCopyConfig();
    this.productClassify = this.addDisabled(this.merPlatProductClassify);
    this.getProductAuditSwitchInfo();
    this.loadMerchantFeatureSwitch();
  },
  methods: {
    checkPermi: checkPermi,
    loadMerchantFeatureSwitch: function () {
      var _loadMerchantFeatureSwitch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var info, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return getBaseInfoApi();
            case 1:
              info = _context.v;
              localStorage.setItem('JavaMerchantBaseInfo', JSON.stringify(info));
              this.showLockFu = !!info.showLockFu;
              this.showBusinessLockDividend = !!info.showBusinessLockDividend;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('获取商户功能开关失败:', _t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadMerchantFeatureSwitch() {
        return _loadMerchantFeatureSwitch.apply(this, arguments);
      }
      return loadMerchantFeatureSwitch;
    }(),
    getConfig: function () {
      var _getConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data1, data, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return getAdminInfoByTokenApi();
            case 1:
              data1 = _context2.v;
              console.log('商家信息:', data1);
              _context2.n = 2;
              return getConfigApi(data1.merId);
            case 2:
              data = _context2.v;
              // 根据实际返回结构调整
              this.isSpecialMerchant = data;
              console.log('是否特殊商家:', this.isSpecialMerchant);
              this.updateRatioRules();
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.error('获取商家配置失败:', _t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function getConfig() {
        return _getConfig.apply(this, arguments);
      }
      return getConfig;
    }(),
    updateRatioRules: function updateRatioRules() {
      var min = this.isSpecialMerchant ? 5 : 3;
      var max = this.isSpecialMerchant ? 80 : 30;
      var range = this.isSpecialMerchant ? '5%~80%' : '3%~30%';
      this.$set(this.ruleValidate, 'ratio', [{
        required: true,
        message: '请输入商品让利比例',
        trigger: 'blur'
      }, {
        validator: function validator(rule, value, callback) {
          if (!value) {
            callback(new Error('请输入商品让利比例'));
          } else if (!/^\d+$/.test(value)) {
            callback(new Error('让利比例必须为整数'));
          } else if (parseInt(value, 10) < min || parseInt(value, 10) > max) {
            callback(new Error("\u8BA9\u5229\u6BD4\u4F8B\u8303\u56F4\u4E3A".concat(range, "\u7684\u6574\u6570")));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }]);

      // 清除旧验证状态
      if (this.$refs.formValidate) {
        this.$refs.formValidate.clearValidate('ratio');
      }
    },
    // 切换默认选中规格
    changeDefault: function changeDefault(e, index) {
      // 一个开启 其他关闭
      this.ManyAttrValue.map(function (item, i) {
        if (i !== index) {
          item.isDefault = false;
        }
      });
      if (e) this.ManyAttrValue[index].isShow = true;
    },
    // 回调规格生成表格数据
    changeManyAttrValue: function changeManyAttrValue(e) {
      // rows数组第一项 新增默认数据 oneFormBatch
      this.ManyAttrValue = e;
    },
    changeIsEditVal: function changeIsEditVal() {
      this.isEditAttrVal = false;
    },
    //批量清空规格中的批量数据
    handleBatchDel: function handleBatchDel() {
      this.oneFormBatch = [{
        image: '',
        price: void 0.01,
        cost: void 0.01,
        otPrice: void 0.01,
        stock: void 0,
        weight: void 0,
        volume: void 0,
        brokerage: void 0,
        brokerageTwo: void 0,
        cdkeyId: null,
        cdkeyLibraryName: '',
        barCode: '',
        itemNumber: '',
        expand: '',
        vipPrice: void 0,
        directPushPrice: 0,
        // ✅ 新增
        recommendPrice: 0 // ✅ 新增
      }];
    },
    //创建、编辑表单
    handlerCreatFrom: function handlerCreatFrom(id, type) {
      handlerCreatFromUse(id, type);
    },
    //系统表单数据
    getSystemFormList: function () {
      var _getSystemFormList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$systemFormPage, list;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return systemFormPageApi({
                page: 1,
                limit: 999
              });
            case 1:
              _yield$systemFormPage = _context3.v;
              list = _yield$systemFormPage.list;
              this.$store.commit('mobildConfig/SET_SystemForm', list);
              localStorage.setItem('systemFormList', JSON.stringify(list));
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getSystemFormList() {
        return _getSystemFormList.apply(this, arguments);
      }
      return getSystemFormList;
    }(),
    //获取商户端商户商品审核开关信息
    getProductAuditSwitchInfo: function getProductAuditSwitchInfo() {
      var _this3 = this;
      productAuditSwitchInfoApi().then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _this3.isSwitch = res.isSwitch;
                _this3.productSwitch = res.productSwitch;
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    //添加商品分类
    handleAddMenu: function handleAddMenu(rowData) {
      this.editDialogConfig.isCreate = 0;
      this.editDialogConfig.prent = rowData;
      this.editDialogConfig.data = {};
      this.editDialogConfig.visible = true;
    },
    hideEditDialog: function hideEditDialog() {
      var _this4 = this;
      this.editDialogConfig.prent = {};
      this.editDialogConfig.type = 0;
      this.editDialogConfig.visible = false;
      setTimeout(function () {
        _this4.$store.dispatch('product/getMerProductClassify');
      }, 200);
    },
    //视频上传前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'video/mp4';
      var isLt2M = file.size / 10240 / 10240 < 2;
      if (!isJPG) {
        this.$message.error('上传视频只能是 mp4 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    // 上传
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(param) {
        var formData, data, loading, res, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              formData = new FormData();
              data = {
                model: 'product',
                pid: 0
              };
              loading = this.$loading({
                lock: true,
                text: '上传中，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              formData.append('multipart', param.file);
              _context5.p = 1;
              _context5.n = 2;
              return uploadImage(formData, data);
            case 2:
              res = _context5.v;
              this.upload.videoIng = true;
              this.videoLink = res.url;
              this.progress = 100;
              loading.close();
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
              loading.close();
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function handleUploadForm(_x2) {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    // 删除视频；
    delVideo: function delVideo() {
      this.$set(this, 'videoLink', '');
    },
    //限制平台商品分类只能选择第三级
    addDisabled: function addDisabled(dropdownList) {
      var _this5 = this;
      var list = [];
      try {
        dropdownList.forEach(function (e, index) {
          var e_new = {
            id: e.id,
            name: e.name,
            level: e.level,
            pid: e.pid,
            isShow: e.isShow
          };
          if (!e.childList && (e.level === 1 || e.level === 2)) {
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              disabled: true
            });
          }
          if (e.childList) {
            var childList = _this5.addDisabled(e.childList);
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              childList: childList
            });
          }
          list.push(e_new);
        });
      } catch (error) {
        return [];
      }
      return list;
    },
    // 生成商品表单
    addProduct: function addProduct() {
      var _this6 = this;
      if (this.url) {
        this.formValidate.content = '';
        this.loading = true;
        this.fullscreenLoading = true;
        this.copyConfig.copyType == 1 ? copyProductApi({
          url: this.url
        }).then(function (res) {
          _this6.getData(res, 'copy');
          // ratio回显时乘以100，保留2位小数
          if (_this6.formValidate.ratio !== undefined && _this6.formValidate.ratio !== null) {
            _this6.formValidate.ratio = _this6.toFixedNumber(_this6.formValidate.ratio * 100, 2);
          }
          _this6.isShowAttr = true;
          _this6.loading = false;
          _this6.fullscreenLoading = false;
        }).catch(function () {
          _this6.loading = false;
          _this6.fullscreenLoading = false;
        }) : importProductApi({
          url: this.url,
          form: this.form
        }).then(function (res) {
          _this6.getData(res, 'copy');
          // ratio回显时乘以100，保留2位小数
          if (_this6.formValidate.ratio !== undefined && _this6.formValidate.ratio !== null) {
            _this6.formValidate.ratio = _this6.toFixedNumber(_this6.formValidate.ratio * 100, 2);
          }
          _this6.isShowAttr = true;
          _this6.loading = false;
          _this6.fullscreenLoading = false;
        }).catch(function () {
          _this6.loading = false;
          _this6.fullscreenLoading = false;
        });
      } else {
        this.$message.warning('请输入链接地址！');
      }
    },
    /**
     * 复制商品转图片路径
     * @param sliderImage轮播图, attrValue规格
     */
    getShopImg: function () {
      var _getShopImg = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(sliderImage, attrValue) {
        var _this7 = this;
        var imgList, attrs, ShopImg, result;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              imgList = _toConsumableArray(JSON.parse(sliderImage));
              attrValue.map(function (item) {
                return imgList.push(item.image);
              });
              attrs = _toConsumableArray(new Set(imgList));
              ShopImg = [];
              attrs.map(function (item) {
                ShopImg.push({
                  key: item,
                  img: item
                });
              });
              _context6.n = 1;
              return this.getShopImgUpload(ShopImg, []);
            case 1:
              result = _context6.v;
              this.formValidate.images = this.formValidate.images.map(function (item, index) {
                if (result[index].key && item === result[index].key) {
                  return result[index].img;
                } else {
                  _this7.formValidate.images.splice(index, 1);
                }
              });
              this.ManyAttrValue.map(function (item, index) {
                result.map(function (items, index) {
                  if (items.key && item.image === items.key) {
                    return item.image = items.img;
                  }
                });
              });
              this.fullscreenLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function getShopImg(_x3, _x4) {
        return _getShopImg.apply(this, arguments);
      }
      return getShopImg;
    }(),
    getShopImgUpload: function () {
      var _getShopImgUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(attrs, arr) {
        var key, res, _t4, _t5;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _t4 = _regeneratorKeys(attrs);
            case 1:
              if ((_t5 = _t4()).done) {
                _context7.n = 3;
                break;
              }
              key = _t5.value;
              _context7.n = 2;
              return this.getImgData(attrs[key].img || attrs[key].sattDir);
            case 2:
              res = _context7.v;
              arr.push({
                key: attrs[key].img || attrs[key].imgsattDir,
                img: res
              });
              _context7.n = 1;
              break;
            case 3:
              return _context7.a(2, arr);
          }
        }, _callee7, this);
      }));
      function getShopImgUpload(_x5, _x6) {
        return _getShopImgUpload.apply(this, arguments);
      }
      return getShopImgUpload;
    }(),
    /**
     * 复制商品图片路径请求接口
     * @param imgUrl
     * @returns {Promise<any>}
     */
    getImgData: function getImgData(imgUrl) {
      var _this8 = this;
      return new Promise(function (resolve, reject) {
        shopImgUploadApi({
          imgUrl: imgUrl,
          respType: 1,
          uploadType: 1
        }).then(function (res) {
          if (res.errcode > 0) {
            _this8.fullscreenLoading = false;
            _this8.$message.error(res.errmsg);
            resolve('');
          } else {
            resolve(res.img_info.temp_img_url);
          }
        });
      });
    },
    getCopyConfig: function getCopyConfig() {
      var _this9 = this;
      copyConfigApi().then(function (res) {
        _this9.copyConfig = res;
      });
    },
    changeGuarantee: function changeGuarantee(val) {
      var _this0 = this;
      if (val) {
        this.guaranteeName = [];
        if (this.isShowGroup === 'combination') {
          var guaranteeGroupids = [];
          var data = this.guaranteeGroupList.filter(function (item) {
            return val.includes(item.id);
          });
          if (data.length) {
            data[0].guaranteeList.map(function (item) {
              return item.isShow && guaranteeGroupids.push(item.gid);
            });
          }
          this.formValidate.guaranteeIds = guaranteeGroupids.toString();
          this.guaranteeList.map(function (item) {
            guaranteeGroupids.map(function (j) {
              if (item.id === j) _this0.guaranteeName.push(item.name);
            });
          });
        }
      } else {
        this.guaranteeName = [];
        this.$set(this.formValidate, 'guaranteeIdsList', null);
      }
    },
    //选择保障服务模式
    onchangeIsShow: function onchangeIsShow() {
      this.multiples = !this.multiples;
      this.guaranteeName = [];
      this.formValidate.guaranteeIds = '';
      if (this.isShowGroup === 'combination') {
        this.guaranteeNew = this.guaranteeGroupList;
        this.$set(this.formValidate, 'guaranteeIdsList', '');
      } else {
        this.$set(this.formValidate, 'guaranteeIdsList', []);
        this.guaranteeNew = this.guaranteeList;
      }
    },
    // 服务组合列表
    getGuaranteeGroupList: function getGuaranteeGroupList() {
      var _this1 = this;
      guaranteeListApi().then(function (res) {
        _this1.guaranteeGroupList = res;
      });
    },
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
    },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].childList || data[i].childList.length < 1) {
            data[i].childList = undefined;
          } else {
            this.changeNodes(data[i].childList);
          }
        }
      }
      return data;
    },
    // 保障服务列表
    getProductGuarantee: function getProductGuarantee() {
      var _this10 = this;
      productGuaranteeApi().then(function (res) {
        _this10.guaranteeList = res.filter(function (item) {
          return item.isShow;
        });
        _this10.guaranteeNew = _this10.guaranteeList;
      });
    },
    onChangeCategory: function onChangeCategory() {
      this.formValidate.brandId = '';
      this.brandList = [];
      this.getbrandList();
      this.brandList.push({
        name: '其他',
        id: 0
      });
    },
    // 下拉加载更多
    selectLoadMore: function selectLoadMore() {
      this.search.page = this.search.page + 1;
      if (this.search.page > this.totalPage) return;
      this.getbrandList(); // 请求接口
    },
    // 远程搜索
    remoteMethod: function remoteMethod(query) {
      var _this11 = this;
      this.loading = true;
      this.search.brandName = query;
      this.search.page = 1;
      setTimeout(function () {
        _this11.loading = false;
        _this11.getbrandList(); // 请求接口
      }, 200);
    },
    // 品牌列表
    getbrandList: function getbrandList() {
      var _this12 = this;
      this.search.cid = this.formValidate.categoryId;
      brandListApi(this.search).then(function (res) {
        _this12.totalPage = res.totalPage;
        _this12.total = res.total;
        _this12.brandList = _this12.brandList.concat(res.list);
      });
    },
    proving1: function proving1(e) {
      this.formValidate.sort = e.target.value.replace(/[^\.\d]/g, '');
      this.formValidate.sort = e.target.value.replace('.', '');
    },
    onRatioInput: function onRatioInput(val) {
      // 只允许输入3-20之间的数字
      var num = Number(val);
      if (num < 3) this.formValidate.ratio = 3;
      if (num > 20) this.formValidate.ratio = 20;
    },
    handleCloseCoupon: function handleCloseCoupon(tag) {
      this.formValidate.coupons.splice(this.formValidate.coupons.indexOf(tag), 1);
      this.formValidate.couponIds.splice(this.formValidate.couponIds.indexOf(tag.id), 1);
    },
    addCoupon: function addCoupon() {
      var _this = this;
      this.$modalCoupon('wu', this.keyNum += 1, this.formValidate.coupons, function (row) {
        _this.formValidate.couponIds = [];
        _this.formValidate.coupons = row;
        row.map(function (item) {
          _this.formValidate.couponIds.push(item.id);
        });
      }, '');
    },
    setTagsViewTitle: function setTagsViewTitle() {
      if (this.$route.params.id && this.$route.params.id != 0) {
        var title = this.isDisabled ? '商品详情' : '编辑商品';
        var route = Object.assign({}, this.tempRoute, {
          title: "".concat(title, "-").concat(this.$route.params.id)
        });
        this.$store.dispatch('tagsView/updateVisitedView', route);
      } else {
        if (this.isCopy) {
          var _title = '采集商品';
          var _route = Object.assign({}, this.tempRoute, {
            title: "".concat(_title)
          });
          this.$store.dispatch('tagsView/updateVisitedView', _route);
        }
      }
    },
    // 详情
    getInfo: function getInfo() {
      var _this13 = this;
      this.fullscreenLoading = true;
      productDetailApi(this.$route.params.id).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(res) {
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.n) {
              case 0:
                _context8.n = 1;
                return _this13.getData(res, 'add');
              case 1:
                // ratio回显时乘以100，保留2位小数
                if (_this13.formValidate.ratio !== undefined && _this13.formValidate.ratio !== null) {
                  _this13.formValidate.ratio = _this13.toFixedNumber(_this13.formValidate.ratio * 100, 2);
                }
                _this13.isShowAttr = true;
                _this13.fullscreenLoading = false;
              case 2:
                return _context8.a(2);
            }
          }, _callee8);
        }));
        return function (_x7) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this13.fullscreenLoading = false;
      });
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.sliderImages.splice(i, 1);
    },
    // 上一步
    handleSubmitUp: function handleSubmitUp() {
      this.currentTab = (Number(this.currentTab) - 1).toString();
    },
    // 下一步
    handleSubmitNest: function handleSubmitNest(name) {
      var _this14 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this14.currentTab = (Number(_this14.currentTab) + 1).toString();
        } else {
          if (!_this14.formValidate.name || !_this14.formValidate.categoryId || !_this14.formValidate.keyword || !_this14.formValidate.unitName || !_this14.formValidate.intro || !_this14.formValidate.image || !_this14.formValidate.sliderImages || !_this14.formValidate.deliveryMethodList.length
          // ||
          // !this.formValidate.directPushPrice ||
          // !this.formValidate.recommendPrice
          ) {
            _this14.$message.warning('请填写完整商品信息！');
          }
        }
      });
    },
    //保存接口数据更新
    getFromData: function getFromData() {
      var _this15 = this;
      if (this.formValidate.specType && this.formValidate.attrs.length < 1) return this.$message.warning('请填写多规格属性！');
      if (this.videoLink) {
        //如果有视频主图，将视频链接插入到轮播图第一的位置
        this.formValidate.sliderImages.unshift(this.videoLink);
      }
      if (this.isShowGroup === 'alone') this.formValidate.guaranteeIds = this.formValidate.guaranteeIdsList.join(',');
      var attrValueListData = [];
      if (this.formValidate.specType) {
        //规格值
        this.formValidate.attrList = this.formValidate.attrs.map(function (item, index) {
          return {
            attributeName: item.value,
            isShowImage: item.add_pic == 1 ? true : false,
            id: 0,
            sort: index + 1,
            optionList: item.detail.map(function (arr, idx) {
              return {
                image: arr.image,
                optionName: arr.value,
                sort: idx + 1
              };
            })
          };
        });
        //表格数据
        var ManyAttrValues = _toConsumableArray(this.ManyAttrValue);
        attrValueListData = ManyAttrValues;
        attrValueListData.shift();
        for (var i = 0; i < attrValueListData.length; i++) {
          var attrValues = _objectSpread({}, attrValueListData[i].attrValueShow);
          this.$set(attrValueListData[i], 'attrValue', JSON.stringify(attrValues)); //
        }
      } else {
        this.formValidate.attrList = [{
          attributeName: '规格',
          attrValues: '默认',
          isShowImage: false,
          optionList: [{
            optionName: '默认',
            id: 0,
            image: '',
            sort: 1
          }]
        }];
        this.OneattrValue.map(function (item) {
          _this15.$set(item, 'attrValue', JSON.stringify({
            规格: '默认'
          }));
        });
      }
      // ratio提交时除以100，保留4位小数
      var ratio = this.formValidate.ratio;
      if (ratio !== undefined && ratio !== null && ratio !== '') {
        ratio = this.div100(ratio);
      }
      var data = _objectSpread(_objectSpread({}, this.formValidate), {}, {
        ratio: ratio,
        cateId: this.formValidate.cateIds.join(','),
        keyword: this.labelarr.join(','),
        sliderImage: JSON.stringify(this.formValidate.sliderImages),
        deliveryMethod: this.formValidate.deliveryMethodList.join(','),
        systemFormId: this.formValidate.systemFormId ? this.formValidate.systemFormId : 0,
        attrValueList: this.formValidate.specType ? attrValueListData : this.OneattrValue,
        tempId: this.formValidate.type != 0 ? 0 : this.formValidate.tempId
      });
      if (!this.showLockFu) {
        data.isLockFu = 0;
        data.lockFuRatio = undefined;
      } else if (data.isLockFu === 0) {
        data.lockFuRatio = undefined;
      } else {
        // isLockFu=1 时，校验并转换 lockFuRatio 为数字
        var _ratio = parseFloat(data.lockFuRatio);
        if (isNaN(_ratio) || _ratio < 0 || _ratio > 1) {
          this.$message.warning('锁仓福豆比例必须在0到1之间');
          throw new Error('锁仓福豆比例校验失败');
        }
        data.lockFuRatio = _ratio;
      }
      if (!this.showBusinessLockDividend) {
        data.isBusinessLockDividend = 0;
        // 关闭商务锁仓分红时，将5个比例字段设为0
        data.businessManagerRatio = 0;
        data.seniorBusinessManagerRatio = 0;
        data.directorRatio = 0;
        data.seniorDirectorRatio = 0;
        data.presidentRatio = 0;
      } else if (data.isBusinessLockDividend === 1) {
        // 开启商务锁仓分红时，验证5个比例字段
        var ratio1 = parseFloat(data.businessManagerRatio) || 0;
        var ratio2 = parseFloat(data.seniorBusinessManagerRatio) || 0;
        var ratio3 = parseFloat(data.directorRatio) || 0;
        var ratio4 = parseFloat(data.seniorDirectorRatio) || 0;
        var ratio5 = parseFloat(data.presidentRatio) || 0;
        var sum = ratio1 + ratio2 + ratio3 + ratio4 + ratio5;
        if (sum > 1) {
          this.$message.warning('商务锁仓分红比例总和不能超过1');
          throw new Error('商务锁仓分红比例总和不能超过1');
        }

        // 转换为数字类型
        data.businessManagerRatio = ratio1;
        data.seniorBusinessManagerRatio = ratio2;
        data.directorRatio = ratio3;
        data.seniorDirectorRatio = ratio4;
        data.presidentRatio = ratio5;
      } else {
        // isBusinessLockDividend = 0 时，将5个比例字段设为0
        data.businessManagerRatio = 0;
        data.seniorBusinessManagerRatio = 0;
        data.directorRatio = 0;
        data.seniorDirectorRatio = 0;
        data.presidentRatio = 0;
      }
      // 供货商商品售价校验：(售价 - 供货价) / 售价 < 30%，即 售价 < 供货价 / 0.7
      if (this.isSupplier && data.attrValueList && Array.isArray(data.attrValueList)) {
        for (var _i = 0; _i < data.attrValueList.length; _i++) {
          var sku = data.attrValueList[_i];
          var price = parseFloat(sku.price);
          var cost = parseFloat(sku.cost);
          if (!isNaN(price) && !isNaN(cost) && price > 0) {
            var maxPrice = cost / 0.7;
            if (price >= maxPrice) {
              var skuName = sku.suk || sku.sku || "SKU ".concat(_i + 1);
              this.$message.warning("[".concat(skuName, "] \u552E\u4EF7\u5FC5\u987B\u5C0F\u4E8E\u4F9B\u8D27\u4EF7 / 0.7\uFF08\u6700\u9AD8 ").concat(maxPrice.toFixed(2), " \u5143\uFF09"));
              throw new Error('供货商售价校验失败');
            }
          }
        }
      }
      return data;
    },
    //是否自动上架
    automaticListing: function automaticListing() {
      var _this16 = this;
      this.$confirm(this.productSwitch ? '审核通过之后是否自动上架？' : '操作之后是否自动上架？', '提示', {
        confirmButtonText: '上架',
        cancelButtonText: '不用了',
        type: 'warning',
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        customClass: 'deleteConfirm'
      }).then(function () {
        _this16.formValidate.isAutoUp = true;
        _this16.postData();
      }).catch(function (action) {
        if (action === 'cancel') {
          _this16.formValidate.isAutoUp = false;
          _this16.postData();
          // 调用取消按钮的方法
        } else if (action === 'close') {
          // 调用关闭按钮的方法
        }
      });
    },
    //保存并审核
    handleSubmitAndAudit: function handleSubmitAndAudit(name) {
      var _this17 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          //  this.getFromData();
          _this17.formValidate.isAutoSubmitAudit = true;
          _this17.automaticListing();
        } else {
          if (!_this17.formValidate.name || !_this17.formValidate.cateId || !_this17.formValidate.keyword || !_this17.formValidate.unitName || !_this17.formValidate.intro || !_this17.formValidate.image || !_this17.formValidate.sliderImages) {
            _this17.$message.warning('请填写完整商品信息！');
          }
        }
      });
    },
    // 保存
    handleSubmit: function handleSubmit(name) {
      var _this18 = this;
      console.log(this.formValidate, 'formDataformDataformData');
      this.$refs[name].validate(function (valid) {
        if (valid) {
          // this.getFromData();
          //免审商品，保存的时候弹出上架弹窗，条件：店铺开启 && 店铺免审
          if (_this18.isSwitch && !_this18.productSwitch) {
            _this18.formValidate.isAutoSubmitAudit = false;
            _this18.automaticListing();
          } else {
            _this18.formValidate.isAutoUp = false;
            _this18.formValidate.isAutoSubmitAudit = false;
            _this18.postData();
          }
        } else {
          if (!_this18.formValidate.name || !_this18.formValidate.cateId || !_this18.formValidate.keyword || !_this18.formValidate.unitName || !_this18.formValidate.intro || !_this18.formValidate.image || !_this18.formValidate.sliderImages) {
            _this18.$message.warning('请填写完整商品信息！');
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this19 = this;
      this.loadingBtn = true;
      var data;
      try {
        data = this.getFromData();
      } catch (error) {
        // 表单校验失败（如供货商售价校验），重置 loading 状态
        this.loadingBtn = false;
        return;
      }
      // ✅ 提交前确保 attrValueList 中每个 SKU 都包含这两个字段
      if (data.attrValueList && Array.isArray(data.attrValueList)) {
        data.attrValueList.forEach(function (item) {
          if (item.directPushPrice === undefined || item.directPushPrice === null) {
            item.directPushPrice = 0;
          }
          if (item.recommendPrice === undefined || item.recommendPrice === null) {
            item.recommendPrice = 0;
          }
        });
      }
      parseFloat(this.$route.params.id) > 0 ? productUpdateApi(data).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(res) {
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.n) {
              case 0:
                _this19.$message.success('编辑成功');
                setTimeout(function () {
                  _this19.$router.push({
                    path: '/product/list'
                  });
                }, 500);
                _this19.closeSelectedTag();
                _this19.loadingBtn = false;
              case 1:
                return _context9.a(2);
            }
          }, _callee9);
        }));
        return function (_x8) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this19.loadingBtn = false;
      }) : productCreateApi(data).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(res) {
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                _this19.$message.success('新增成功');
                setTimeout(function () {
                  _this19.$router.push({
                    path: '/product/list'
                  });
                }, 500);
                _this19.closeSelectedTag();
                _this19.loadingBtn = false;
              case 1:
                return _context0.a(2);
            }
          }, _callee0);
        }));
        return function (_x9) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this19.loadingBtn = false;
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    closeSelectedTag: function closeSelectedTag() {
      var that = this;
      that.$store.dispatch('tagsView/delView', that.$route).then(function (_ref5) {
        var visitedViews = _ref5.visitedViews;
        if (that.isActive(that.$route)) {
          that.toLastView(visitedViews, that.$route);
        }
      });
    },
    toLastView: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          this.$router.push('/');
        }
      }
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    },
    // 浮点数除法，保留4位小数
    div100: function div100(val) {
      var num = Number(val);
      if (isNaN(num)) return 0;
      return this.toFixedNumber(num / 100, 4);
    },
    // 浮点数处理，保留指定位数
    toFixedNumber: function toFixedNumber(num, digits) {
      if (typeof num !== 'number') num = Number(num);
      if (isNaN(num)) return 0;
      return Number(num.toFixed(digits));
    }
  }
};